import {Injectable, inject, ChangeDetectionStrategy} from '@angular/core';
import {MatSnackBar, MatSnackBarAction, MatSnackBarActions, MatSnackBarLabel, MatSnackBarRef} from '@angular/material/snack-bar';
import {Observable, Subject, take, timer} from 'rxjs';
import {clearIndexKeysFromCache, unregisterServiceWorker} from '@shared/util/cache-util';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from 'src/environments/environment';

import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import {AsyncPipe} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';

@Component({
    imports: [AsyncPipe, MatButtonModule, MatSnackBarLabel, MatSnackBarActions, MatSnackBarAction],
    template: `
    <span matSnackBarLabel>
      Mise à jour disponible <br> Forcée dans {{ data | async }} secondes
    </span>
    <span matSnackBarActions>
      <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">Mettre à jour</button>
  </span>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: `
    :host {
      display: flex;
    }
  `
})
export class SnackBarCheckerUpdateComponent {
  snackBarRef = inject(MatSnackBarRef);
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: Observable<string>) { }
}

@Injectable({
  providedIn: 'root'
})
export class CheckerUpdateService {

  private countdown$: Subject<number> = new Subject<number>();
  private readonly TWO_HOURS = 2 * 60 * 60 * 1000;
  private readonly FIVE_MINUTES = 5 * 60 * 1000;

  constructor(
    private _http: HttpClient,
    private _snackBar: MatSnackBar,
  ) {
    timer(this.FIVE_MINUTES, this.TWO_HOURS)
      .subscribe(() => this.checkForUpdate());
  }

  private checkForUpdate() {
    const now = Date.now();
    const httpParam = new HttpParams().set('v', now);
    this._http.get('/assets/version.json?', {params : httpParam, headers: {'ngsw-bypass': 'true'}})
      .subscribe((data: {version: string}) => {
        const latestVersion = data.version;
        const currentVersion = environment.gitTag || environment.gitCommitId;
        if (latestVersion !== currentVersion && !!latestVersion) {
          this._notifyUser();
          this._startTimerBeforeForceUpdateAfter5Min();
        }
    });
  }

  private _notifyUser() {
    const snack = this._snackBar.openFromComponent(SnackBarCheckerUpdateComponent, {
      data: this.countdown$
    });
    snack.onAction().subscribe(async () => {
      await clearIndexKeysFromCache();
      await unregisterServiceWorker();
      document.location.reload();
    });
  }

  private _startTimerBeforeForceUpdateAfter5Min() {
    timer(0, 1000).pipe(
      take(5 * 60)
    ).subscribe({
      next: (timer) => {
        this.countdown$.next((5 * 60) - timer);
      }, complete: async () => {
        await clearIndexKeysFromCache();
        await unregisterServiceWorker();
        document.location.reload();
      }
    });
  }

}
